export const DEFAULT_KEEPALIVE_INITIAL_DELAY = 30000;

export const DEFAULT_COMMAND_TIMEOUT = 5000;
